import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { useSmartNavigation } from '@/hooks/useSmartNavigation';
import { PageSpinner } from '../ui/PageSpinner';
// import { AuthProvider } from './path/to/your/AuthContext'; // Example: for global state

/**
 * The RootLayout is the highest-level layout for the entire application.
 *
 * It's the perfect place to put:
 * 1. Context Providers (like for authentication, themes, etc.)
 * 2. Global components that are not part of a specific layout (e.g., a toast/notification system)
 * 3. An <Outlet /> to render all the nested routes.
 */


type RootLayoutProps = {
  children?: React.ReactNode;
};

export const RootLayout = ({ children }: RootLayoutProps) => {
  const { showSpinner } = useSmartNavigation();

  return (
    <div>
      {showSpinner && <PageSpinner />}

      <div style={{ opacity: showSpinner ? 0.5 : 1, transition: 'opacity 0.2s' }}>
        {children ?? <Outlet />}
      </div>

      <Toaster />
    </div>
  );
};

export default RootLayout;